import { render, staticRenderFns } from "./target-pin.vue?vue&type=template&id=51978304&"
import script from "./target-pin.vue?vue&type=script&lang=js&"
export * from "./target-pin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51978304')) {
      api.createRecord('51978304', component.options)
    } else {
      api.reload('51978304', component.options)
    }
    module.hot.accept("./target-pin.vue?vue&type=template&id=51978304&", function () {
      api.rerender('51978304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/target-pin.vue"
export default component.exports